//imports
import React from "react";
import {useIntl} from "react-intl";
import {useParams} from "react-router-dom";

//controls
import {Container, TabContainer} from "@gpstrackit/gtc-react-controls";

//styles
// import "./main.scss";
//views
import BehaviorReportView from "../report";

const MaintenanceMainView = () => {
    const {messages} = useIntl();
    const {id} = useParams();

    const tabItem =
        {
            label: messages["behavior_reportView"],
            index: 0,
            component: <BehaviorReportView/>,
        };


    return (
        <Container maxWidth={false} className="container-view">
            <TabContainer key={tabItem.index} label={tabItem.label} index={tabItem.index}>
                {tabItem.component}
            </TabContainer>
        </Container>
    );
};

export default MaintenanceMainView;
